import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
@Component({
  selector: 'app-auth-callback-page',
  templateUrl: './auth-callback-page.component.html',
  styleUrl: './auth-callback-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AuthCallbackPageComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  protected readonly error = signal<string | null>(null);

  ngOnInit(): void {
    void this.completeSignIn();
  }

  private async completeSignIn(): Promise<void> {
    const account = this.authService.ensureActiveAccount();

    if (!account) {
      await this.router.navigateByUrl('/login', { replaceUrl: true });
      return;
    }

    try {
      await firstValueFrom(this.authService.getCurrentUser());
      await this.router.navigateByUrl('/valuations', { replaceUrl: true });
    } catch (err) {
      this.error.set(err instanceof Error ? err.message : 'Unable to complete sign-in.');
    }
  }

  protected navigateToLogin(): void {
    void this.router.navigateByUrl('/login', { replaceUrl: true });
  }
}
